module.exports = __webpack_public_path__ + "static/media/candidate-hired.84f75a43.svg";